/* ==========================================================================
   Capelle shared JS. Served from the theme on every page, deferred.
   Replaces the <script> half of the GemPages Shared Code element.
   Version: v31 (2026-09-02). Update this file, never the GemPages element.
   No async or await anywhere, since the GemPages minifier used to kill it
   and the Custom Code elements still poll for these globals.
   ========================================================================= */
/* ============================================================================
   Current product handle, read from the URL rather than Liquid. Liquid
   metafield lookups return empty inside a GemPages Custom Code element.
   ========================================================================= */
window.capHandle = (function () {
  var parts = location.pathname.split('/products/');
  if (parts.length < 2) return '';
  return parts[1].split(/[?#]/)[0];
})();

/* Paginated fetch for the JSON collection view. collection.json.liquid
   paginates by 50, so a full page means there may be another one. Every
   path passed in must already carry ?view=json. */
window.capFeed = function (path) {
  var out = [];
  var joiner = path.indexOf('?') > -1 ? '&' : '?';
  function page(n) {
    if (n > 8) return out;
    return fetch(path + joiner + 'page=' + n)
      .then(function (r) { return r.json(); })
      .then(function (batch) {
        if (!batch || !batch.length || Object.prototype.toString.call(batch) !== '[object Array]') return out;
        out = out.concat(batch);
        /* Stop on a short page. A collection that is an exact multiple of 50
           still costs one empty round trip, which is unavoidable without
           knowing the count up front. */
        if (batch.length < 50) return out;
        return page(n + 1);
      })
      .catch(function () { return out; });
  }
  return page(1);
};

/* Both swatch feeds plus the current product's own record, fetched once and
   cached for every block on the page.

   The .final filter is the trap 1 guard. A tag path that matches nothing
   returns an unfiltered slice of the collection rather than an empty array.

   Self is resolved BEFORE extensions are stripped. Extension listings all
   carry Final Sale, so filtering first would leave a 3" or 5XL/6XL page
   unable to find itself, which is what blanks the Color label. */
window.capSwatchFeeds = (function () {
  var promise = null;
  return function () {
    if (!promise) {
      promise = Promise.all([
        capFeed('/collections/swatch-source/active?view=json'),
        capFeed('/collections/swatch-source/final-sale?view=json')
      ]).then(function (res) {
        var cur = res[0].filter(function (p) { return !p.final; });
        var lc = res[1].filter(function (p) { return p.final; });
        /* v32. Resolve self from the RAW feeds before any filtering. An
           extension card carries Final Sale, so the active filter drops it,
           and if it is not in the final-sale collection it vanished from
           both lists and every self-driven block hid itself.
           v33. raw is passed out too, so the More Lengths & Sizes tab can
           build the colorway family (main, extensions, boys) from one pool. */
        var raw = res[0].concat(res[1]);
        var self = null;
        for (var i = 0; i < raw.length; i++) {
          if (raw[i].handle === capHandle) { self = raw[i]; break; }
        }
        return { cur: cur, lc: lc, self: self, raw: raw };
      }).catch(function () {
        return { cur: [], lc: [], self: null, raw: [] };
      });
    }
    return promise;
  };
})();

window.capMoney = function(c){ return '$' + (c/100).toFixed(2).replace(/\.00$/,'') + ' USD'; };

window.capCard = function(p){
  var badge = (p.badges && p.badges.length) ? p.badges[0] : (p.final ? 'Final Sale' : '');
  var save = (p.compare > p.price) ? Math.round((p.compare - p.price) / p.compare * 100) : 0;
  return '<a class="cap-card" href="' + p.url + '">'
    + '<div class="cap-flags">'
    + (badge ? '<span class="cap-badge">' + badge + '</span>' : '<span></span>')
    + (save ? '<span class="cap-save">Save ' + save + '%</span>' : '<span></span>')
    + '</div>'
    + '<div class="cap-media">'
    + '<img src="' + p.image + '" alt="' + String(p.short).replace(/"/g,'') + '" loading="lazy">'
    + (p.alt ? '<img class="cap-alt" src="' + p.alt + '" alt="" loading="lazy" aria-hidden="true">' : '')
    + '</div>'
    + '<span class="cap-name">' + String(p.short).replace(/\s*[–—-]\s*/, '<br>') + '</span>'
    + '<span class="cap-price">' + window.capMoney(p.price)
    + (p.compare > p.price ? '<s>' + window.capMoney(p.compare) + '</s>' : '')
    + '</span></a>';
};

/* Scans tab controls only. The previous version walked every a, button,
   div, span, li, p and heading in the document and read textContent on each,
   which on a GemPages page is thousands of nodes, once per hidden block.
   TAB_SEL is the same selector the old version used to walk UP to the tab,
   so anything it could find, this finds. */
window.capTabSel = '[class*="gp-tab"], [class*="tab-item"], [role="tab"]';

window.capHide = function(box, label){
  box.style.display = 'none';
  if (!label) return;
  var target = String(label).trim().toLowerCase();
  /* v10. Scope the search to the tab group this body belongs to. With two
     Tab elements on one page, a document-wide search hid the matching label
     in whichever group came first, which was often the wrong one. */
  var scope = (box.closest && box.closest('[class*="gp-tab"], [class*="tabs"], [class*="tab-wrap"]')) || document;
  var tabs = scope.querySelectorAll(window.capTabSel);
  if (!tabs.length) tabs = document.querySelectorAll(window.capTabSel);
  for (var i = 0; i < tabs.length; i++) {
    var tab = tabs[i];
    if (String(tab.textContent).trim().toLowerCase() !== target) continue;
    if (tab.querySelector('#cap-swatch, span.money, .cap-fs-block')) return;
    tab.style.display = 'none';
    return;
  }
};

/* ----------------------------------------------------------------------------
   capEqualize

   Levels the card name blocks so every price in a row sits on the same
   baseline. Clears every name, then reads every name, then writes every
   name, three separate loops. Skips grids with no offsetParent, which is a
   closed tab. Re-runs on image load and first visibility.
   -------------------------------------------------------------------------- */
window.capEqualize = function(grid){
  if (!grid) return;
  var names = grid.querySelectorAll('.cap-name');
  if (!names.length) return;
  if (!grid.offsetParent) return;

  var i;
  for (i = 0; i < names.length; i++) names[i].style.minHeight = '';

  var tall = 0;
  for (i = 0; i < names.length; i++) {
    if (names[i].offsetHeight > tall) tall = names[i].offsetHeight;
  }
  if (!tall) return;

  for (i = 0; i < names.length; i++) names[i].style.minHeight = tall + 'px';
};

window.capEqualizeAll = function(){
  var grids = document.querySelectorAll('.cap-grid');
  for (var i = 0; i < grids.length; i++) window.capEqualize(grids[i]);
};

/* ----------------------------------------------------------------------------
   capBundleLabels. v18.

   Shopify builds bundle option names from the full component product title,
   so the picker reads "Men's Premium Compression-Lined Hybrid Shorts - Sand
   Waves-Harbor and Surf (Size)". CSS cannot change text, so rewrite it.

   Result: "Sand Waves, Harbor and Surf short (size)".
   Only runs on a bundle page, which is any page carrying #cap-bp.
   -------------------------------------------------------------------------- */
/* ----------------------------------------------------------------------------
   capBundleOpts. v28. THE FIX.

   v18 through v27 all tried to read the option names off the rendered page,
   first by scanning elements, then by walking text nodes. Neither found
   anything. That is the answer, not a failure. GemPages does not render the
   option name on this template, so there is no text to find and no amount of
   DOM scanning will ever produce any.

   Shopify knows the option names server side. The bundle picker element now
   emits them as JSON in #cap-bp-opts. Reading them from there makes the size
   chart filter independent of whether the theme renders anything at all.
   -------------------------------------------------------------------------- */
window.capBundleOpts = function(){
  var el = document.getElementById('cap-bp-opts');
  if (!el) return [];
  var d;
  try { d = JSON.parse(el.textContent || '{}'); } catch (e) { return []; }
  var raw = (d && d.options) || [], out = [];
  for (var i = 0; i < raw.length; i++) {
    var nm = String(raw[i].name || '');
    if (!nm) continue;
    var vals = raw[i].values || [];
    /* An option name MAY carry a trailing axis bracket, as Shopify generates
       it. Yours were renamed and no longer do, so the axis is inferred from
       the values instead. Values are the only reliable signal here. */
    var m = nm.match(/^([\s\S]*?)\s*\(([^)]+)\)\s*$/);
    out.push({
      name:   nm,
      part:   m ? m[1].trim() : nm.trim(),
      axis:   m ? m[2].trim().toLowerCase() : window.capAxis(vals),
      values: vals
    });
  }
  return out;
};

/* Infer whether an option is a size axis or a length axis from its values.
     S, M, XL, 2XL, 5-6           size
     6" Classic, 9" Long, 9 inch  length
   Anything else returns empty and is treated as a size. */
window.capAxis = function(vals){
  var sz = 0, ln = 0;
  for (var i = 0; i < vals.length; i++) {
    var v = String(vals[i]).trim();
    if (/^(XXS|XS|S|M|L|XL|\d?X{0,1}L|\d+XL)$/i.test(v)) { sz++; continue; }
    if (/^\d+\s*-\s*\d+$/.test(v)) { sz++; continue; }              /* boys years */
    if (/\d\s*("|\u201d|inch|in\b)|classic|long|short/i.test(v)) { ln++; continue; }
  }
  if (ln > sz) return 'length';
  if (sz) return 'size';
  return '';
};

/* Which garment a component name describes. Boys is tested first because a
   boys title also contains the word short. */
window.capGarment = function(t){
  if (/boys/i.test(t)) return 'boys';
  if (/shirt/i.test(t)) return 'shirt';
  if (/short|trunk|hybrid/i.test(t)) return 'short';
  return '';
};

/* ----------------------------------------------------------------------------
   capVariantText. v28.
   Kept as a fallback for any page that does render the label, and it now
   walks open shadow roots as well as the light DOM. The 12 character floor
   is gone, it was capable of rejecting a short label, and the garment test
   only applies to text long enough to plausibly carry a product title.
   -------------------------------------------------------------------------- */
window.capVariantText = function(){
  var out = [];
  if (!document.body || !document.createTreeWalker) return out;

  function scan(root, depth){
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var n;
    while ((n = w.nextNode())) {
      var pe = n.parentElement;
      if (!pe) continue;
      var tag = pe.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') continue;
      var t = String(n.nodeValue || '').replace(/\s+/g, ' ').trim();
      if (!t || t.length > 220) continue;
      if (!/\((Size|Length|Years)\)/i.test(t)) continue;
      if (t.length > 40 && !/hybrid|shirt|short|trunk|boys/i.test(t)) continue;
      out.push({node: n, el: pe, text: t});
    }
    /* Open shadow roots are invisible to a TreeWalker rooted on document.body.
       Bounded to two levels so this cannot become a whole page crawl. */
    if (depth >= 2 || !root.querySelectorAll) return;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) scan(all[i].shadowRoot, depth + 1);
    }
  }

  scan(document.body, 0);
  return out;
};

window.capBundleLabels = function(){
  if (!document.getElementById('cap-bp')) return 0;

  function colorway(t){
    var m = t.match(/\u2013\s*([^(]+?)\s*\(/);
    if (m && m[1]) return m[1].trim();
    m = t.match(/-\s*([^(-]+?)\s*\(/);
    if (m && m[1]) return m[1].trim();
    m = t.match(/^(.+?)\s+Boys/i);
    if (m && m[1]) return m[1].trim();
    return '';
  }

  var found = window.capVariantText(), done = 0;
  for (var i = 0; i < found.length; i++) {
    var raw = found[i].text;

    /* Match the bracket immediately before the colon. Boys values read
       "5-6 (Years)" and carry their own brackets. */
    var om = raw.match(/\(([^)]+)\)\s*:\s*([\s\S]*)$/) || raw.match(/\(([^)]+)\)\s*$/);
    if (!om) continue;
    var opt = String(om[1]).toLowerCase();
    var val = om.length > 2 && om[2] ? String(om[2]).trim() : '';
    var col = colorway(raw).replace(/\s+/g, ' ');
    var g   = window.capGarment(raw);
    if (!g) continue;
    if (g === 'boys') g = 'boys short';

    var piece = (col ? col + ' ' : '') + g;
    var line2 = opt.charAt(0).toUpperCase() + opt.slice(1) + (val ? ': ' + val : '');

    /* Swap the text node itself, leaving every sibling element untouched. */
    var s1 = document.createElement('span'); s1.className = 'cap-vl__n'; s1.textContent = piece;
    var s2 = document.createElement('span'); s2.className = 'cap-vl__v'; s2.textContent = line2;
    var pn = found[i].node.parentNode;
    if (!pn) continue;
    pn.replaceChild(s2, found[i].node);
    pn.insertBefore(s1, s2);
    done++;
  }
  return done;
};

/* v28. The observer is debounced. v27 called both functions synchronously on
   every mutation, and capBundleLabels itself mutates, so the page was doing
   far more work than it needed to. Poll count trimmed from 40 to 24. */
window.capBundleLabelsWatch = function(){
  if (!document.getElementById('cap-bp')) return;
  var tries = 0, timer = null;
  function run(){
    window.capBundleLabels();
    window.capMergeVariantValue();
    window.capSetsChart();
  }
  (function poll(){
    run();
    if (++tries < 24) setTimeout(poll, 250);
  })();
  if (window.MutationObserver) {
    var mo = new MutationObserver(function(){
      if (timer) return;
      timer = setTimeout(function(){ timer = null; run(); }, 200);
    });
    mo.observe(document.body, {childList: true, subtree: true});
  }
};

window.capSetsChart = function(){
  var sc = document.querySelector('.cap-sc[data-sets]');
  if (!sc) return 0;

  var want = {short6: false, short9: false, shirt: false, boys: false};
  var opts = window.capBundleOpts(), decided = false;

  if (opts.length) {
    /* Group by component, so a shorts component contributing both a (Size)
       and a (Length) option is read as one garment rather than two. */
    var parts = {}, i, pool = [];
    for (i = 0; i < opts.length; i++) {
      if (opts[i].axis === 'length') pool = pool.concat(opts[i].values);
    }
    for (i = 0; i < opts.length; i++) {
      /* A length axis is not a garment of its own. Its values go into the
         pool above and it is skipped here, otherwise a renamed length option
         such as "Salt Spray short length" registers as a second short. */
      if (opts[i].axis === 'length') continue;
      var key = opts[i].part;
      if (!parts[key]) parts[key] = {lengths: pool};
    }
    for (var k in parts) {
      if (!Object.prototype.hasOwnProperty.call(parts, k)) continue;
      var g = window.capGarment(k);
      if (g === 'boys')  { want.boys  = true; decided = true; continue; }
      if (g === 'shirt') { want.shirt = true; decided = true; continue; }
      if (g !== 'short') continue;
      decided = true;
      /* Length can come from a length axis's values or from the component
         name itself, e.g. "Sunset Spritz, Ocean and Heat 9\" Long short". */
      var L = parts[k].lengths.join(' ') + ' ' + k;
      var six  = /(^|\D)6\s*("|\u201d|inch|in\b)|6\s*Classic|\bClassic\b/i.test(L);
      var nine = /(^|\D)9\s*("|\u201d|inch|in\b)|9\s*Long|\bLong\b/i.test(L);
      if (six)  want.short6 = true;
      if (nine) want.short9 = true;
      /* No Length option, or values naming no inch measure. Cannot tell which
         chart applies, so show both rather than hide the right one. */
      if (!six && !nine) { want.short6 = true; want.short9 = true; }
    }
  }

  /* Fallback for any page that does render the labels. */
  if (!decided) {
    var found = window.capVariantText(), labels = [], j;
    for (j = 0; j < found.length; j++) labels.push(found[j].text);
    /* Once capBundleLabels has rewritten a label the original wording is
       gone, so read the rewritten pieces too. */
    var rw = document.querySelectorAll('.cap-vl__n');
    for (var r = 0; r < rw.length; r++) {
      var n1 = String(rw[r].textContent || '');
      var sib = rw[r].nextElementSibling;
      var n2 = sib ? String(sib.textContent || '') : '';
      labels.push(n1 + ' (' + n2.split(':')[0].trim() + ')');
    }
    if (!labels.length) return 0;
    for (j = 0; j < labels.length; j++) {
      var g2 = window.capGarment(labels[j]);
      if (g2 === 'boys')  { want.boys  = true; continue; }
      if (g2 === 'shirt') { want.shirt = true; continue; }
      if (g2 === 'short') {
        want.short6 = true;
        if (/\(Length\)/i.test(labels[j])) want.short9 = true;
      }
    }
  }

  /* A chart may carry one combined short group rather than separate 6 and 9
     inch groups. data-piece="short" matches whenever either applies. */
  want.short = want.short6 || want.short9;

  var grps = sc.querySelectorAll('.cap-sc__grp'), shown = 0, m;
  for (m = 0; m < grps.length; m++) {
    var piece = grps[m].getAttribute('data-piece');
    var on = !!want[piece];
    grps[m].style.display = on ? '' : 'none';
    if (on) shown++;
  }
  /* Never leave the tab empty. If nothing matched, show everything. */
  if (!shown) {
    for (m = 0; m < grps.length; m++) grps[m].style.display = '';
    return 0;
  }
  return shown;
};

/* ----------------------------------------------------------------------------
   capMergeVariantValue. v28.

   GemPages renders the selected variant on three lines, the option name, the
   axis word, then the value:

       Sunset Spritz, Ocean and Heat short
       Size
       2XL

   The axis word and the value are separate text nodes in separate elements,
   which is why nothing keyed on "(Size)" ever touched them. This merges the
   two into one line and hides the now empty node:

       Sunset Spritz, Ocean and Heat short
       Size: 2XL

   Deliberately keyed on nothing but text, since GemPages class names are
   generated and change between builds. Idempotent, because once a node reads
   "Size: 2XL" it no longer matches the axis test.
   -------------------------------------------------------------------------- */
window.capAxisWord = /^(size|length|years|waist|inseam)$/i;

/* Scope the walk to the buy box rather than the whole page. */
window.capBuyBox = function(){
  var bp = document.getElementById('cap-bp');
  if (!bp) return null;
  var el = bp;
  for (var i = 0; i < 4 && el.parentElement; i++) el = el.parentElement;
  return el;
};

window.capMergeVariantValue = function(){
  var scope = window.capBuyBox();
  if (!scope || !document.createTreeWalker) return 0;

  var w = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null, false);
  var list = [], n;
  while ((n = w.nextNode())) {
    var pe = n.parentElement;
    if (!pe) continue;
    var tg = pe.tagName;
    if (tg === 'SCRIPT' || tg === 'STYLE' || tg === 'NOSCRIPT') continue;
    var t = String(n.nodeValue || '').replace(/\s+/g, ' ').trim();
    if (!t) continue;
    list.push({node: n, el: pe, text: t});
  }

  function selectable(el){
    return !!(el.closest && el.closest('button, label, input, select, option, [role="radio"], [role="option"], [role="tab"]'));
  }
  function plausibleValue(t){
    return t.length <= 14 && /^[0-9A-Za-z"'\u201d\u2013\-\/ ]+$/.test(t);
  }

  var done = 0;
  for (var i = 0; i < list.length; i++) {
    /* Case A, axis and value already share one node: "Size 2XL". */
    var one = list[i].text.match(/^(size|length|years|waist|inseam)\s+(\S[\s\S]{0,13})$/i);
    if (one) {
      list[i].node.nodeValue = one[1] + ': ' + one[2];
      done++;
      continue;
    }
    /* Case B, the live one. Axis word alone, value in the next text node. */
    if (!window.capAxisWord.test(list[i].text)) continue;
    if (selectable(list[i].el)) continue;
    var v = list[i + 1];
    if (!v) continue;
    if (!plausibleValue(v.text)) continue;
    if (selectable(v.el)) continue;
    if (list[i].el.contains(v.el) || v.el.contains(list[i].el)) continue;

    list[i].node.nodeValue = list[i].text + ': ' + v.text;
    if (v.el.classList) v.el.classList.add('cap-vl-hide');
    done++;
    i++;
  }
  return done;
};

/* ----------------------------------------------------------------------------
   capDiag. v28. Paste capDiag() into the console on a live bundle PDP and it
   reports which of the three possible states the page is in, in one call.

     optsParsed  greater than 0  the Liquid payload is present and the chart
                                 filter is driven by it. This is the good path.
     optsParsed  0               picker v9 is not pasted, or the element is
                                 not on this template.
     domLabels   0               confirms the labels are not rendered, which
                                 is why every earlier version did nothing.
   -------------------------------------------------------------------------- */
window.capDiag = function(){
  var opts = window.capBundleOpts();
  var sc = document.querySelector('.cap-sc[data-sets]');
  var names = [];
  for (var i = 0; i < opts.length; i++) names.push(opts[i].axis + ' :: ' + opts[i].part);
  return {
    picker:      !!document.getElementById('cap-bp'),
    optsPayload: !!document.getElementById('cap-bp-opts'),
    optsParsed:  opts.length,
    optNames:    names,
    chartFound:  !!sc,
    groups:      sc ? sc.querySelectorAll('.cap-sc__grp').length : 0,
    domLabels:   window.capVariantText().length,
    merged:      window.capMergeVariantValue(),
    labelsRan:   window.capBundleLabels(),
    chartShown:  window.capSetsChart()
  };
};


window.capHideEmptyTabs = function(){
  document.querySelectorAll('.cap-tab-body').forEach(function(b){
    if (String(b.textContent).trim() !== '') return;
    var label = b.getAttribute('data-label');
    window.capHide(b, label);
  });
};

window.capCareIcons = {
  wash: '<svg viewBox="0 0 100 100" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round">'
    + '<path d="M 20,35 L 25,75 Q 25,85 35,85 L 65,85 Q 75,85 75,75 L 80,35 Z"/>'
    + '<path d="M 20,48 Q 35,56 50,48 T 80,48"/>'
    + '<line x1="20" y1="92" x2="80" y2="92"/>'
    + '<text x="50" y="30" font-size="16" font-weight="bold" text-anchor="middle" fill="currentColor" stroke="none">30&#176;</text></svg>',
  hangdry: '<svg viewBox="0 0 100 100" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round">'
    + '<rect x="20" y="20" width="60" height="60" rx="4"/>'
    + '<line x1="50" y1="35" x2="50" y2="65" stroke-width="6"/></svg>',
  notumble: '<svg viewBox="0 0 100 100" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round">'
    + '<rect x="20" y="20" width="60" height="60" rx="4"/>'
    + '<circle cx="50" cy="50" r="22"/>'
    + '<line x1="22" y1="22" x2="78" y2="78" stroke-width="6"/></svg>',
  nobleach: '<svg viewBox="0 0 100 100" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round">'
    + '<polygon points="50,20 85,80 15,80"/>'
    + '<line x1="20" y1="25" x2="80" y2="85" stroke-width="6"/>'
    + '<line x1="80" y1="25" x2="20" y2="85" stroke-width="6"/></svg>',
  noiron: '<svg viewBox="0 0 100 100" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round">'
    + '<path d="M 20,65 L 75,65 C 85,65 85,50 75,50 L 60,50 C 45,50 35,35 20,35 Z"/>'
    + '<line x1="20" y1="25" x2="80" y2="75" stroke-width="6"/>'
    + '<line x1="80" y1="25" x2="20" y2="75" stroke-width="6"/></svg>',
  nodryclean: '<svg viewBox="0 0 100 100" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round">'
    + '<circle cx="50" cy="50" r="30"/>'
    + '<line x1="22" y1="22" x2="78" y2="78" stroke-width="6"/>'
    + '<line x1="78" y1="22" x2="22" y2="78" stroke-width="6"/></svg>'
};

window.capCareRender = function(){
  document.querySelectorAll('.cap-tab-body.cap-care li').forEach(function(li){
    if (li.querySelector('svg')) return;
    var t = li.textContent.toLowerCase(), icons = '';
    if (t.indexOf('wash') !== -1) icons += window.capCareIcons.wash;
    if (t.indexOf('hang dry') !== -1) icons += window.capCareIcons.hangdry;
    if (t.indexOf('tumble') !== -1) icons += window.capCareIcons.notumble;
    if (t.indexOf('bleach') !== -1) icons += window.capCareIcons.nobleach;
    if (t.indexOf('dry clean') !== -1) icons += window.capCareIcons.nodryclean;
    if (t.indexOf('iron') !== -1) icons += window.capCareIcons.noiron;
    if (icons) li.insertAdjacentHTML('afterbegin', '<span class="cap-icons">' + icons + '</span>');
  });
};

(function(){

  var obs = new MutationObserver(function(muts){
    muts.forEach(function(m){
      if (m.target.classList && m.target.classList.contains('cap-grid')) {
        window.capEqualize(m.target);
        watchImages(m.target);
      }
    });
  });

  /* Card images carry loading="lazy" and height:auto, so card geometry is
     not final until they land. */
  function watchImages(grid){
    var imgs = grid.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].complete) continue;
      if (imgs[i].getAttribute('data-cap-eq')) continue;
      imgs[i].setAttribute('data-cap-eq', '1');
      imgs[i].addEventListener('load', function(){ window.capEqualize(grid); });
      imgs[i].addEventListener('error', function(){ window.capEqualize(grid); });
    }
  }

  /* A grid inside a closed tab lays out for the first time when the tab is
     opened, after the injection pass has already run. */
  function watchVisibility(grid){
    if (typeof IntersectionObserver !== 'function') return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) window.capEqualize(e.target);
      });
    }, { threshold: 0.01 });
    io.observe(grid);
  }

  function attach(){
    var grids = document.querySelectorAll('.cap-grid');
    if (!grids.length) return setTimeout(attach, 300);
    grids.forEach(function(g){
      obs.observe(g, { childList: true });
      watchVisibility(g);
      watchImages(g);
      window.capEqualize(g);
    });
  }
  attach();

  /* Tab switches do not always change the DOM, so hook the click as well.
     Scoped to clicks that land on a tab control rather than every click on
     the page, and fires once rather than twice. The IntersectionObserver
     above already catches a grid becoming visible, so the 250ms follow-up
     was redundant. */
  document.addEventListener('click', function(e){
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest(window.capTabSel)) return;
    setTimeout(window.capEqualizeAll, 0);
  }, true);

  var t = 0;
  function sweep(){
    var bodies = document.querySelectorAll('.cap-tab-body');
    if (!bodies.length && ++t < 40) return setTimeout(sweep, 250);
    window.capHideEmptyTabs();
    window.capCareRender();
    window.capBundleLabelsWatch();
    window.capSetsChart();
  }
  sweep();

  /* Debounced. resize fires many times a second while a window is dragged,
     and on mobile every time the URL bar collapses on scroll. Undebounced
     this ran a full measure and write pass on each event. */
  var rz = 0;
  window.addEventListener('resize', function(){
    clearTimeout(rz);
    rz = setTimeout(window.capEqualizeAll, 150);
  });

  window.addEventListener('load', function(){
    window.capEqualizeAll();
    window.capBundleLabelsWatch();
    window.capSetsChart();
  });

})();